import React from 'react';
import { classNames } from '@panwds/tailwindcss';

function CardFooter({ addClassName, children, dataMetrics, dataTestId, noDivider, secondaryContent, footerMessage, ...passThrough }) {
    if (passThrough.appearance) {
        console.warn('Appearance has been deprecated and will be ignored!');
    }
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'card-footer', className: classNames('tw-box-border tw-border-solid tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-gray-300 tw-flex tw-flex-0 tw-rounded-b tw-px-4 tw-py-2', noDivider ? 'dark:tw-border-0' : 'dark:tw-border-gray-950', footerMessage ? 'tw-justify-between' : 'tw-justify-end', addClassName), ...passThrough },
        footerMessage && React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-2" }, footerMessage),
        React.createElement("div", { className: "tw-flex tw-space-x-2" },
            children && React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-2" }, children),
            secondaryContent && (React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-2" }, secondaryContent)))));
}

export { CardFooter };
//# sourceMappingURL=CardFooter.esm.js.map
